module.exports = __webpack_public_path__ + "static/media/droneLive.91d2a6ec.png";